import { type JsmErrorResponseDto, JsmGenericFriendlyReason } from '../types';

export class JsmClientError extends Error {
  public code = 0;
  public responseBody: JsmErrorResponseDto;

  constructor(code: number, responseBody: any) {
    super(`Status code ${code}`);
    this.name = 'JsmClientError';
    this.code = code;

    this.responseBody = {
      friendlyReason:
        responseBody.friendlyReason !== undefined ? responseBody.friendlyReason : JsmGenericFriendlyReason,
      technicalReason:
        responseBody.technicalReason !== undefined
          ? responseBody.technicalReason
          : responseBody.detail !== undefined
            ? responseBody.detail
            : responseBody.message !== undefined
              ? responseBody.message
              : responseBody.reasonKey !== undefined
                ? responseBody.reasonKey
                : typeof responseBody === 'string'
                  ? responseBody
                  : null,
    };
  }
}
